import React, { useEffect, useState } from 'react';
import Card from '../../components/card';
import { formatDate } from '../../components/formatters';
import { isObjectModified } from '../../components/property-mapper';
import CompareField from './compare-field';
import CompareAddress from './compare-address';

const BeneficiaryReview = ({modified, unmodified}) => {
    const [isModified, setIsModified] = useState();
    const getType = (type) => {
        if(!type)
            return null;
        return type === 1 ? "Primary": "Contingent";
    }

    useEffect(() => {
        if(!modified || !unmodified)
            setIsModified(true);
        else
            setIsModified(isObjectModified(modified, unmodified));
        
    }, [])

    return ( 
        <Card title={
                <div className='text-sm'>
                    <span className={isModified ? 'text-purple' : 'text-danger'}>{modified.firstName} {modified.lastName}</span>
                </div>        }>
        <CompareField title="First Name" modifiedValue={modified.firstName} unmodifiedValue={unmodified?.firstName} />
        <CompareField title="Last Name" modifiedValue={modified.lastName} unmodifiedValue={unmodified?.lastName} />
        <CompareField title="Relationship" modifiedValue={modified?.relationship?.name} unmodifiedValue={unmodified?.relationship?.name} />
        <CompareField title="Social Security Number" modifiedValue={modified.ssn} unmodifiedValue={unmodified?.ssn} />
        <CompareAddress title="Address" modified={modified?.address} unmodified={unmodified?.address} />
        <CompareField title="Percentage" modifiedValue={modified?.percentage} unmodifiedValue={unmodified?.percentage} />
        <CompareField title="Type" modifiedValue={getType(modified?.type)} unmodifiedValue={getType(unmodified?.type)} />
        </Card>
 );
}
 
export default BeneficiaryReview;